<template>

  <div class="clause-part card_b no_box_open_style">
    <div class="head" @click="toggleOpen">
        <h3 v-text="part?.title"></h3>
        <div class="icon" :class="isOpen ? 'chevron_up_blue_icon' : 'chevron_down_blue_icon'"></div>
    </div>
    <div class="clauses_scroll" ref="clausesScroll" @blur="handleBlur" @focus="handleFocus">
      <div class="clauses-container" v-if="isOpen">
        <clause-item
          v-for="(clause, i) in part.clauses"
          :key="clause.id"
          :clause="clause"
          :index="i"
          :selected-ents="selectedEnts"
          :entsWidth="entsWidth"
          :mode="mode"
          :editable="editable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ClauseItem from './ClauseItem.vue';
import { grabScrollMixin } from '@/mixins/grabScroll';

export default {
  name: 'ClausePart',

  components: {
    ClauseItem
  },
  mixins: [grabScrollMixin],
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    part: {
      type: Object,
      required: true
    },
    selectedEnts: {
      type: Array,
      default: () => []
    },
    entsWidth: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: 'edit',
      validator: (value) => ['edit', 'watch'].includes(value)
    }
  },
  data() {
    return {
      isOpen: this.part.isOpen,
      scrollCleanup: null
    };
  },
  emits: ['toggle-clause', 'handleTableScroll'],
  methods: {
    handleBlur() {
      this.scrollCleanup();
    },
    handleFocus() {
      this.setupComponentScrollSync();
    },
    toggleOpen() {
      this.isOpen = !this.isOpen;
      
      // Initialize scroll sync after content is toggled
      if (this.isOpen) {
        this.$nextTick(() => {
          this.setupComponentScrollSync();
        });
      } else if (this.scrollCleanup) {
        this.scrollCleanup();
      }
    },

    setupComponentScrollSync() {
      // Clean up previous scroll synchronization if exists
      if (this.scrollCleanup) return;

      const clausesScroll = this.$refs.clausesScroll;
      
      if (clausesScroll) {
        // Emit scroll event to parent component for parent-level syncing
        const handleScrollEvent = () => {
          console.log(this.$refs);
          this.$emit('handleTableScroll', clausesScroll);
          // if (this.$refs.ents) {
          //   this.$refs.ents.scrollLeft = clausesScroll.scrollLeft;
          // }
        };
        
        // Add event listener for local scroll events
        clausesScroll.addEventListener('scroll', handleScrollEvent, { passive: true });
        
        // Store cleanup function
        this.scrollCleanup = () => {
          clausesScroll.removeEventListener('scroll', handleScrollEvent);
          this.scrollCleanup = null;
        };
      }
    }
  },
  mounted() {
    // Initialize grab scroll behavior
    this._grabScrollCleanup = this.initGrabScroll(
      this.$refs.clausesScroll,
      (element) => this.$emit('handleTableScroll', element),
      ['flex-cell', 'arrow-icon'] // Pass the excluded classes
    );
    if(this.isOpen) {
      // Initialize scroll synchronization
      this.$nextTick(() => {
        this.setupComponentScrollSync();
      });
    }
  },
  beforeUnmount() {
    // Clean up grab scroll
    if (this._grabScrollCleanup) {
      this._grabScrollCleanup();
    }
    
    // Clean up scroll sync
    if (this.scrollCleanup) {
      this.scrollCleanup();
    }
  }
}
</script>

<style lang="scss" scoped>
.clause-part {
  margin-bottom: var(--gap); 
  // width: fit-content;    min-width: 100%;
  
  .part-title {
    font-weight: 700;
    font-size: var(--h4);
    margin-bottom: var(--gap_small);
    padding: 10px;
    background: var(--gray);
    border-radius: 4px;
  }
  
  .clauses_scroll { overflow-y: auto; 
    &::-webkit-scrollbar {
      width: 10px;
      display: none;
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    
  }
  .clauses-container {
    // display: grid;
    //         grid-template-columns: var(--title_width) 1fr; column-gap: var(--gap); row-gap: 5px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: fit-content;
  }
}
</style> 